// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xBaseTheme } from "@ces/XDL/types";
import color from "@ces/XDL/Utilities/color";
import { IconWrapper } from "@insite/mobius/Icon";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { css } from "styled-components";

export default {
    defaultProps: {
        css: css`
            color: ${color("text.link")};
            &:not(:disabled):focus {
                outline: none;
            }
            &:not(:disabled):hover,
            &:not(:disabled):focus {
                ${TypographyStyle} {
                    color: ${color("common.ui8")};
                }
            }
            &:disabled {
                &,
                ${TypographyStyle}, ${IconWrapper} {
                    color: ${color("text.link", 0.33)};
                }
            }
        `,
    },
} as xBaseTheme["clickable"];
